<template>
    <div class="cabinet-content-wrap">
        <header
            id="supplier-cabinet-header-d"
            class="cabinet-header flex flex-align-center"
        >
            <h1 class="h1 cabinet-title">Настройки аккаунта</h1>
        </header>

        <header
            id="supplier-cabinet-header-m"
            class="cabinet-header flex flex-align-center  justify-content-between hide"
        >
            <a
                id="supplier-cabinet-back"
                href="javascript:void(0)"
                class="cabinet-btn--form-back-header-edit"
            ></a>
            <h1 id="supplier-cabinet-title" class="h1 cabinet-title"></h1>
            <div class="cabinet-btn--form-back-header-edit hidden"></div>
        </header>

        <section
            class="supplier-nav supplier-nav--settings flex flex-align-center"
        >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link active"
                data-target="personal-data"
                >Личные данные</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="legal-data"
                >Юридические данные</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="password"
                >Пароль</a
            >
            <a
                href="javascript:void(0)"
                class="supplier-nav__link"
                data-target="docs"
                >Документы</a
            >
        </section>

        <retailer-personal-data />

        <retailer-legal-data />

        <retailer-password />

        <retailer-docs />
    </div>
</template>

<script>
import RetailerPersonalData from '@/components/Cabinet/Retailer/Settings/PersonalData'
import RetailerLegalData from '@/components/Cabinet/Retailer/Settings/LegalData'
import RetailerPassword from '@/components/Cabinet/Retailer/Settings/Password'
import RetailerDocs from '@/components/Cabinet/Retailer/Settings/Docs'

import supplierNav from '@/mixins/supplier-nav'

import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'RetailerSettings',
    components: {
        RetailerPersonalData,
        RetailerLegalData,
        RetailerDocs,
        RetailerPassword
    },
    mixins: [supplierNav],
    mounted() {
        this.$nextTick(() => {
            this.supplierNav()
        })
    }
}
</script>
